import { render, staticRenderFns } from "./CampaignNotesManualNote.vue?vue&type=template&id=6abe3c50&functional=true"
import script from "./CampaignNotesManualNote.vue?vue&type=script&lang=js"
export * from "./CampaignNotesManualNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.106.2_postcss@8.5.15___lodash@4.18.1_pre_97827144a0f6aa48df0612a675550f8c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports